import axios from "axios";
import store from "@/store";

axios.defaults.baseURL = process.env.VUE_APP_API_URL || "";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || ""
})

axios.interceptors.request.use(
  (config) => {
    const publicPages = ["/token", "/status"];
    const authRequired = !publicPages.includes(config.url);
    const isTokenSet = store.getters["auth/isTokenSet"];
    const token = store.getters["auth/token"];

    if (authRequired && isTokenSet) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

 const VueAxiosPlugin = {
     // noinspection JSUnusedGlobalSymbols
     // eslint-disable-next-line no-unused-vars
     install: (app, _) => {
         app.config.globalProperties.$axios={ ...axiosInstance }
     }
}

export default VueAxiosPlugin;
